module.exports = __webpack_public_path__ + "img/74.5.COD.ac0932e0.png";